import DIApi from './_diApi';

class JusticeCaseTypeAPI extends DIApi {
  controllerName = 'JusticeCaseTypes';
}

export default new JusticeCaseTypeAPI();
